var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pa-3",
      staticStyle: { position: "relative", height: "calc(100vh - 100px)" }
    },
    [
      _vm.paginationLoading || _vm.coTableLoader
        ? _c(
            "v-layout",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                "z-index": "1000",
                background: "rgba(255, 255, 255, .95)"
              },
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _c("div", { staticClass: "lds-roller" }, [
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div"),
                  _c("div")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Patientez SVP ...")])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("item-condition", { on: { loadedTypes: _vm.handleLoadedTypes } }),
      _vm._v(" "),
      _c(
        "v-layout",
        { class: _vm.layoutPadding, attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-card",
            {
              staticClass: "attachment__list",
              attrs: { flat: "", color: "transparent" }
            },
            [
              _c(
                "v-data-table",
                {
                  staticClass:
                    "dr-table--transparent dr-table__profile elevation-2",
                  attrs: {
                    headers: _vm.coHeaders,
                    items: _vm.coDocuments,
                    pagination: _vm.newPagination,
                    "total-items": _vm.pagination.total,
                    loading: _vm.paginationLoading || _vm.coTableLoader,
                    "rows-per-page-items": [10, 25, 50],
                    "rows-per-page-text": "Lignes par page",
                    "no-data-text": "Pas de données disponibles"
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.newPagination = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c(
                            "tr",
                            {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  _vm.handleClickDoc(props.item)
                                }
                              }
                            },
                            [
                              _c(
                                "td",
                                { staticClass: "primary--text" },
                                [
                                  _c(
                                    "v-avatar",
                                    {
                                      attrs: {
                                        color: _vm.isDocumentSelected(
                                          props.item.id
                                        )
                                          ? "#2E038C !important"
                                          : "#eee !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          _vm.handleAvatarClick(
                                            props.item.id,
                                            props.item.fk_media_entity
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "headline",
                                          class: {
                                            "white--text": _vm.isDocumentSelected(
                                              props.item.id
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm._f("attachment_type")(
                                                  props.item.name
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.coTableLoader
                                ? [
                                    _c("td", { staticClass: "primary--text" }, [
                                      _c("div", [
                                        _vm._v(_vm._s(props.item.name))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "italic--text grey--text"
                                        },
                                        [_vm._v(_vm._s(props.item.reference))]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "primary--text",
                                        class: {
                                          "empty--column": !props.item.createdAt
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("date_format")(
                                              props.item.createdAt
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "primary--text",
                                        class: {
                                          "empty--column": !props.item
                                            .creator_name
                                        }
                                      },
                                      [_vm._v(_vm._s(props.item.creator_name))]
                                    )
                                  ]
                                : [
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("document-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("document-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "primary--text" },
                                      [
                                        _c("document-table-loader", {
                                          attrs: { "loader-type": "column" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                              _vm._v(" "),
                              !_vm.coTableLoader
                                ? _c(
                                    "td",
                                    { staticClass: "primary--text px-0" },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            "pr-4": "",
                                            "justify-end": ""
                                          }
                                        },
                                        [
                                          props.item.attributes.length > 0
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      $event.preventDefault()
                                                      return (function(e) {
                                                        return _vm.handleShowMore(
                                                          e,
                                                          props.item
                                                        )
                                                      })($event)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.dtAttributeItem ===
                                                          props.item.id
                                                          ? "expand_less"
                                                          : "expand_more"
                                                      )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return (function(e) {
                                                    return _vm.handleShowMenu(
                                                      e,
                                                      props.item
                                                    )
                                                  })($event)
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("more_horiz")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._l(props.item.attributes, function(attribute) {
                            return _vm.dtAttributeItem === props.item.id
                              ? _c("tr", [
                                  _c("td"),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c("base-attribute-value", {
                                        attrs: { attribute: attribute }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("td"),
                                  _vm._v(" "),
                                  _c("td"),
                                  _vm._v(" "),
                                  _c("td")
                                ])
                              : _vm._e()
                          })
                        ]
                      }
                    }
                  ])
                },
                [
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t(_vm.lblSetting.documentTableNoData)) +
                        "\n            "
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtDocMenu.item
        ? _c(
            "v-menu",
            {
              attrs: {
                "position-x": _vm.dtDocMenu.x,
                "position-y": _vm.dtDocMenu.y,
                absolute: "",
                "offset-y": ""
              },
              model: {
                value: _vm.dtDocMenu.active,
                callback: function($$v) {
                  _vm.$set(_vm.dtDocMenu, "active", $$v)
                },
                expression: "dtDocMenu.active"
              }
            },
            [
              _c(
                "v-list",
                [
                  _vm.canManageDocument(_vm.dtDocMenu.item.fk_media_entity)
                    ? _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary--text__action py-1 ma-0",
                              attrs: { text: "", flat: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  _vm.handleEditDocument(_vm.dtDocMenu.item.id)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "pr-2", attrs: { small: "" } },
                                [_vm._v("edit")]
                              ),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t(_vm.lblSetting.documentEdit)) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary--text__action py-1 ma-0",
                          attrs: { text: "", flat: "" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.handleShareDoc($event)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "pr-2", attrs: { small: "" } },
                            [_vm._v("share")]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t(_vm.lblSetting.documentShare)) +
                              "\n        "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.canManageDocument(_vm.dtDocMenu.item.fk_media_entity)
                    ? _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary--text__action py-1 ma-0",
                              attrs: { text: "", flat: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  _vm.handleDeleteDocument(
                                    _vm.dtDocMenu.item.id
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "pr-2", attrs: { small: "" } },
                                [_vm._v("delete")]
                              ),
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(_vm.lblSetting.documentDelete)
                                  ) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleCloseErrorModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenDeleteMessage
        ? _c("base-delete-dialog", {
            attrs: {
              "is-loading": _vm.dtIsLoading,
              message: _vm.coDocumentDelectionMessage
            },
            on: {
              cancel: _vm.handleDeleteDocumentCancel,
              delete: _vm.handleDeleteDocumentOK
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cd621f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cd621f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/documents/components/document-attachments/template.html
// module id = null
// module chunks = 